import { createContext } from "react";
import { MenuBlockItemCollection } from "../data/menuData/menuData";





export const MenuBlocksContext = createContext<MenuBlockItemCollection>({} as MenuBlockItemCollection);